import styled, { keyframes } from 'styled-components';
import colors from 'Styles/colors';

export const Input = styled.input`
  height: 0;
  width: 0;
  opacity: 0;
  z-index: -1;
`;
Input.displayName = 'Input';

const popIn = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1.5) ;
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1) ;
  }
`;

export const Label = styled.label`
  position: relative;
  display: block;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  font-size: 13.5px;
  font-weight: normal;
  line-height: 20px;
  text-align: left;
  color: ${colors.dark2};
  padding-left: 30px;
  margin: 0px 15px 22px 0;
  `;
Label.displayName = 'Label';

export const Indicator = styled.div`
  border: 1px solid #c6c6c6;
  border-radius: 1em;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  left: 0px;

  &::after {
    content: "";
    position: absolute;
    display: none;
  }

  ${Input}:checked + & {
    background: #93d289;
    border: 2px solid #67b75a;
  }

  ${Input}:checked + &::after {
    display: block;
    border: 1px solid #67b75a;
    border-radius: 1em;
    background-color: #eff8fe;
    width: 8px;
    height: 8px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation-name: ${popIn};
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
  }

  ${Input}:disabled + & {
    pointer-events: none;
    opacity: 0.6;
    background: #e6e6e6;
  }
`;
